import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import PageHero from '../ui/pageHero/PageHero';
import CtaSection from '../sections/home/cta/CtaSection';
import { fadeUp, stagger, viewportOnce } from '../../styles/animations';

const values = [
    {
        title: 'Clarity',
        description: 'We say what we mean, in plans clients can actually act on — not decks that look good and change nothing.',
    },
    {
        title: 'Craft',
        description: 'Strategy and engineering held to the same bar. Neither one is an afterthought to the other.',
    },
    {
        title: 'Accountability',
        description: 'We stay through delivery. A recommendation we won’t help build isn’t one we make.',
    },
];

const AboutPage = () => (
    <>
        <PageHero
            eyebrow="About"
            title="Why Nexora exists"
        />

        <Box component="section" sx={{ backgroundColor: 'background.default', py: { xs: 8, md: 12 }, px: '6%' }}>
            <Box sx={{ maxWidth: 800, margin: '0 auto' }}>
                <motion.div initial="hidden" whileInView="visible" viewport={viewportOnce} variants={fadeUp}>
                    <Typography variant="body1" sx={{ mb: 3, fontSize: '1.1rem' }}>
                        Most technology consultancies specialize in one half of the problem —
                        the strategy or the software. Nexora was built on the belief that
                        separating the two is exactly why so many transformation efforts stall.
                    </Typography>
                    <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                        We work as one team across both, from the first framing conversation
                        to the system running in production. That continuity is the point —
                        not a strategy phase followed by a handoff, but one accountable team
                        the whole way through.
                    </Typography>
                </motion.div>
            </Box>
        </Box>

        <Box component="section" sx={{ backgroundColor: 'ink.main', color: 'ink.contrastText', py: { xs: 8, md: 12 }, px: '6%' }}>
            <Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
                <Typography variant="overline" sx={{ color: 'primary.main', display: 'block', mb: 5 }}>
                    How we work
                </Typography>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={viewportOnce}
                    variants={stagger(0.1)}
                    style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '48px' }}
                >
                    {values.map((v) => (
                        <motion.div key={v.title} variants={fadeUp}>
                            <Typography variant="h3" sx={{ mb: 1.5 }}>{v.title}</Typography>
                            <Typography variant="body2" sx={{ color: 'fog' }}>{v.description}</Typography>
                        </motion.div>
                    ))}
                </motion.div>
            </Box>
        </Box>

        <CtaSection />
    </>
);

export default AboutPage;
